import { Box, Slide, Stack } from '@mui/material'
import React, { FC, useContext } from 'react'

import PaymentPanel from '../../components/Estimates/PaymentPanel/PaymentPanel'
import RelatedPanel from '../../components/Estimates/RelatedPanel'
import InspectionsPanel from '../../components/InspectionsPanel/InspectionsPanel'
import { TABLET_WIDTH_BREAKPOINT } from '../../config/breakPoints'
import { FeatureFlags } from '../../models/FeatureFlags'
import { WindowSizeContext } from '../../providers'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'
import { CustomerEntry } from '../../sdk'
import SummaryPanelContainer from './SummaryPanelContainer'

interface Props {
  customerChatIsOpen: boolean
  setCustomerChatIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  repairOrderId: string
  customer: CustomerEntry
}

export const EstimateSidePanel: FC<Props> = ({
  customerChatIsOpen,
  setCustomerChatIsOpen,
  repairOrderId
}) => {
  const { width } = useContext(WindowSizeContext)
  const overTabletBreakpoint = width >= TABLET_WIDTH_BREAKPOINT
  const { featureFlags } = useContext(AppContext)
  const { inspections } = useContext(RepairOrderContext)

  const enableInspections =
    featureFlags && featureFlags[FeatureFlags.DigitalInspection]
  const overTabletBreakpointDisplay = (
    <Box>
      <Stack pt={2}>
        {!customerChatIsOpen && (
          <Slide in={!customerChatIsOpen} direction="left">
            <Stack spacing={1}>
              <RelatedPanel
                repairOrderId={repairOrderId}
                setCustomerChatIsOpen={setCustomerChatIsOpen}
              />
              {enableInspections && (
                <InspectionsPanel
                  repairOrderId={repairOrderId}
                  inspections={inspections}
                />
              )}
              <SummaryPanelContainer repairOrderId={repairOrderId} />
              <PaymentPanel repairOrderId={repairOrderId} />
            </Stack>
          </Slide>
        )}
      </Stack>
    </Box>
  )

  const underTabletBreakpointDisplay = (
    <Stack spacing={1}>
      {enableInspections && (
        <InspectionsPanel
          repairOrderId={repairOrderId}
          inspections={inspections}
        />
      )}
      <SummaryPanelContainer repairOrderId={repairOrderId} />
      <PaymentPanel repairOrderId={repairOrderId} />
    </Stack>
  )

  return overTabletBreakpoint
    ? overTabletBreakpointDisplay
    : underTabletBreakpointDisplay
}
